export default __webpack_public_path__ + "static/media/iustin_rotariu.7e48306a.png";